import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_AUTH_CONTEXT = {
  gates: [],
  user: undefined,
  portal: undefined
};
export const AuthContext = /*#__PURE__*/createContext(EMPTY_AUTH_CONTEXT);
export const AuthContextProvider = ({
  children,
  value
}) => {
  return /*#__PURE__*/_jsx(AuthContext.Provider, {
    value: value || EMPTY_AUTH_CONTEXT,
    children: children
  });
};
export const useAuthContext = () => {
  return useContext(AuthContext);
};